// extracted by mini-css-extract-plugin
export default {"icon":"SearchTabs-module__icon___FieMw"};